import fetchPost from '@/api/http.js'   
export function decrypt(str) {
    return fetchPost('/saas/decrypt/decryptStr', {str})
}
